import { SegmentStatistique } from './../models/SegmentStatistique';
import { ParametreGeneral } from './../models/ParametreGeneral';
import { InfoData } from './../models/InfoData';
import { Garantie } from './../models/Garantie';
import { PortefeuilleDetail } from './../models/PortefeuilleDetail';
import { Portefeuille } from './../models/Portefeuille';
import { SegmentationPrudentielle } from './../models/SegmentationPrudentielle';
import { ParametreEntityPondere } from './../models/ParametreEntityPondere';
import { ParametreNotation } from './../models/ParametreNotation';
import { ParametrePondere } from './../models/ParametrePondere';
import { TypeFinancement } from './../models/TypeFinancement';
import { TypeGarantie } from './../models/TypeGarantie';
import { Rule } from './../models/Rule';
import { ImportInfoData } from './../models/ImportInfoData';
import { ImportGarantie } from './../models/ImportGarantie';
import { ImportPortefeuilleDetail } from './../models/ImportPortefeuilleDetail';
import { ImportPortefeuille } from './../models/ImportPortefeuille';
import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
  providedIn: 'root'
})
export class FondsPropresService {


  constructor(
    public config: RestClientService
  ) {}

  /**
  * 
  * Import Portefeuille Block
  * 
  */
  getImportPortefeuilles(){
    return  this.config.load<ImportPortefeuille[]>('fonds-propres/importation/get-import-portefeuilles');
  }
  getImportPortefeuille(importPortefeuilleId: number){
    return  this.config.load<ImportPortefeuille>('fonds-propres/importation/get-import-portefeuille-by-id/'+importPortefeuilleId);
  }

  saveDatasAndFileImportation(importData: any) {
    return  this.config.save<any>('fonds-propres/importation/save-datas-and-file-importation', importData);
  }
  updateDatasAndFileImportation(importData: any) {
    console.log(importData);
    return  this.config.save<any>('fonds-propres/importation/update-datas-and-file-importation', importData);
  }

  deleteImportPortefeuille(importPortefeuilleId: number) {
    return  this.config.delete<any>('fonds-propres/importation/delete-import-portefeuille-by-id/'+importPortefeuilleId);
  }

  validatePortefeuilleById(importPortefeuilleId: number) {
    return  this.config.load<any>('fonds-propres/portefeuille/validate-portefeuille-by-id/'+importPortefeuilleId);
  }

  getImportPortefeuilleDetails_old(importPortefeuilleId: number){
    return  this.config.load<ImportPortefeuilleDetail[]>('fonds-propres/importation/get-import-portefeuille-details/'+importPortefeuilleId);
  }

  getImportPortefeuilleDetails(importPortefeuilleId, filter, page, size, sortColomun, direction){

    return  this.config.load<any>(`fonds-propres/importation/get-import-portefeuille-details/${importPortefeuilleId}?filter=${filter}&page=${page}&size=${size}&sortColomun=${sortColomun}&direction=${direction}`);
  }


   getImportGaranties(importPortefeuilleId: number, codeDossier: string) {
    return  this.config.load<ImportGarantie[]>('fonds-propres/importation/get-import-garanties/'+importPortefeuilleId+'/'+codeDossier);
  }

  getImportInfoDatasByImportPortefeuilleId(importPortefeuilleId: number) {
    return  this.config.load<ImportInfoData[]>('fonds-propres/importation/get-import-info-datas/'+importPortefeuilleId);
  }
  
  /**************************************************** */


  /**
  * 
  *  Portefeuille Block
  * 
  */
  getPortefeuilles(){
    return  this.config.load<Portefeuille[]>('fonds-propres/portefeuille/get-portefeuilles');
  }
  getPortefeuille(portefeuilleId: number){
    return  this.config.load<Portefeuille>('fonds-propres/portefeuille/get-portefeuille-by-id/'+portefeuilleId);
  }

  deletePortefeuille(portefeuilleId: number) {
    return  this.config.delete<any>('fonds-propres/portefeuille/delete-portefeuille-by-id/'+portefeuilleId);
  }



  getPortefeuilleDetails(portefeuilleId, filter, page, size, sortColomun, descending){

    return  this.config.load<any>(`fonds-propres/portefeuille/get-portefeuille-details/${portefeuilleId}?filter=${filter}&page=${page}&size=${size}&sortColomun=${sortColomun}&descending=${descending}`);
  }

   getGaranties(portefeuilleId: number, codeDossier: string) {
    return  this.config.load<Garantie[]>('fonds-propres/portefeuille/get-garanties/'+portefeuilleId+'/'+codeDossier);
  }

  getInfoDatasByPortefeuilleId(portefeuilleId: number) {
    return  this.config.load<InfoData[]>('fonds-propres/portefeuille/get-info-datas/'+portefeuilleId);
  }

/******************************************************/
getPortefeuilleSegmentStatistique(portefeuilleId: number) {
   
  return  this.config.load<SegmentStatistique[]>('fonds-propres/portefeuille/get-portefeuille-segment-statistiques/'+portefeuilleId);
}


/********************* */
  /** 
  * 
  * Rules
  *
  */
  getSegmentRulesImport(importPortefeuilleDetailId: number) {
    return  this.config.load<Rule[]>('fonds-propres/rules/get-segment-rules-import/'+importPortefeuilleDetailId);
  }
  getSegmentRules(portefeuilleDetailId: number) {
    return  this.config.load<Rule[]>('fonds-propres/rules/get-segment-rules/'+portefeuilleDetailId);
  }
  /**
   * 
   * @returns Gestion des parametres
   */
  getRules() {
    return  this.config.load<Rule[]>('fonds-propres/rules/get-rules');
  }
  getTypeGaranties() {
    return  this.config.load<TypeGarantie[]>('fonds-propres/type-garanties/get-type-garanties');
  }

  getTypeFinancements() {
    return  this.config.load<TypeFinancement[]>('fonds-propres/type-financements/get-type-financements');
  }

  ////////ParametrePondere
  getParametrePonderes() {
    return  this.config.load<ParametrePondere[]>('fonds-propres/parametres-pp/get-parametres-ponderes');
  }
  SupprimerParametrePondere(id: any) {
    return  this.config.delete<any>('fonds-propres/parametres-pp/delete-parametre-pondere-by-id/'+ id);
  }
  updateParametrePondere(data: any) {
    return  this.config.save<any>('fonds-propres/parametres-pp/update-parametre-pondere', data);
  }
  saveParametrePondere(data: ParametrePondere) {
    return  this.config.save<ParametrePondere>('fonds-propres/parametres-pp/save-parametre-pondere', data);
  }


  ////////ParametreNotation
  getParametreNotations() {
    return  this.config.load<ParametreNotation[]>('fonds-propres/parametres-pn/get-parametres-notations');
  }
  updateParametreNotation(data: ParametreNotation) {
    return  this.config.save<ParametreNotation>('fonds-propres/parametres-pn/update-parametre-notation', data);
  }
  saveParametreNotation(data: ParametreNotation) {
    return  this.config.save<ParametreNotation>('fonds-propres/parametres-pn/save-parametre-notation', data);
  }
  SupprimerParametreNotation(parametreNotationId: any) {
    return  this.config.delete<any>('fonds-propres/parametres-pn/delete-parametre-notation-by-id/'+ parametreNotationId);
  }

  ///////ParametreEntityPondere
  getParametreEntityPonderees() {
    return  this.config.load<ParametreEntityPondere[]>('fonds-propres/parametres-pep/get-parametres-entity-ponderes');
  }

  getSegmentationPrudentielles() {
    return  this.config.load<SegmentationPrudentielle[]>('fonds-propres/segmentations/get-segmentations');
  }



  ////ParametreGeneral
  getParametreGenerals() {
    return  this.config.load<ParametreGeneral[]>('fonds-propres/parametres-g/get-parametres-generaux');
  }

  updateParametreGeneral(data: any) {
    return  this.config.save<any>('fonds-propres/parametres-g/update-parametre-general', data);
  }

}
